/**
 * Formats an ISO date as a short US date (e.g. "Dec 5, 2026"), or '' when the
 * string doesn't parse.
 */
export function formatShortDate(iso: string): string {
    const date = new Date(iso);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
